import { useLocation, useNavigate } from 'react-router-dom';
import { UserRole } from '../types/types';

const useCheckLastPathParam = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userId = localStorage.getItem('user_id');
    const userRoleId = localStorage.getItem('user_role_id');
    const userRole = userRoleId ? parseInt(userRoleId) as UserRole : null;
    const pathSegments = location.pathname.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];

    // Admin and ProductAdmin can edit any seller; others only their own profile
    if (userRole === UserRole.Admin || userRole === UserRole.ProductAdmin) {
        return;
    }
    if (lastSegment !== userId) {
        navigate('/not-authorized');
    }
};

export default useCheckLastPathParam;